import React, { FC } from 'react'

import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'

import { APP_PATHS } from '../../routes/paths'

import { LogoImg } from './LogoImg'

export const Logo: FC = () => {
  return (
    <Box component={Link} to={APP_PATHS.root} width="fit-content">
      <LogoImg />
    </Box>
  )
}
